import { render, staticRenderFns } from "./TableBodyRow.vue?vue&type=template&id=620019ae&scoped=true&"
import script from "./TableBodyRow.vue?vue&type=script&lang=js&"
export * from "./TableBodyRow.vue?vue&type=script&lang=js&"
import style0 from "./TableBodyRow.vue?vue&type=style&index=0&id=620019ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620019ae",
  null
  
)

export default component.exports